/**
 * Helpers for develop, rc, production and localhost environments.
 */

/**
 * Is this production site {boolean} - //taide.art
 */
export const isProdSite =
    !!window.location.hostname.match(/^taide\.art$/);


/**
 * Is this RC site {boolean} -         //rc[a-z0-9_-]*.taide*  //testi?.taide*
 */
export const isRcSite =
    !!(window.location.hostname.match(/^rc[\w-]*\.taide*/)
    || window.location.hostname.match(/^testi?\.taide*/));



/**
 * Is this development site {boolean} - //dev.taide* and localhost
 */
export const isDevSite =
    !!window.location.hostname.match(/^dev\.taide/)
    || process.env.NODE_ENV === 'development';


/**
 * Is this live web site {boolean} - not localhost or test
 */
export const isWebSite =
    isProdSite || isRcSite || isDevSite;


/**
 * Is this test env {boolean}
 */
export const isTestEnv =
    process.env.NODE_ENV === 'test';


/**
 * Is this localhost or test {boolean} - ie. not develop, rc or prod
 * Without checking for the environment, test would match too.
 */
export const isLocalHost =
    !!window.location.hostname.match('localhost')
    && process.env.NODE_ENV !== 'test';


/**
 * Matomo script SiteId.
 *   1  taide.art
 *   2  dev
 *   3  testi
 *   4  rc1
 */
export const getMatomoSiteId = () => {
    switch (window.location.hostname) {

    case 'taide.art':
        return 1;

    case 'dev.taidekokoelmat.fi':
        return 2;

    case 'testi.taidekokoelmat.fi':
        return 3;

    case 'rc1.taide.art':
        return 4;
    default:
        return 2;
    }
};


export default {
    isProdSite,
    isRcSite,
    isDevSite,
    isWebSite,
    isLocalHost,
    isTestEnv
};
